import React, { Fragment, useContext, useState } from "react";
import styled from "styled-components";
import { ContainerNew, SubMenu } from "../Layout";
import { _O } from "../../modules/utils";
import { IC } from "../../resources/Assets";
import { AppContext } from "../../components/AppProvider";
import { getCookie } from "../../modules/utils/cookie";

export default () => {
  const { userinfo, phonecfg, cfg } = useContext(AppContext);

  const bottom = (
    <div
      className="under-fix-btnarea"
      style={{ textAlign: "center", margin: "0px 15px", width: "auto" }}
    >
      <form name="form_certificate" method="post">
        <input type="hidden" name="m" value="checkplusSerivce" />
        <input type="hidden" name="EncodeData" id="enc_data" />
        <input type="hidden" name="param_r1" id="userToken" />
        {/* <input type="hidden" name="param_r2" value="mobile" /> */}
        <input type="hidden" name="param_r2" value={phonecfg.phoneOS} />
        <input
          type="hidden"
          name="param_r3"
          id="signUpChannel"
          value={getCookie("signUpChannel")}
        />
      </form>

      <BtnNext
        innerWidth={window.innerWidth}
        onClick={() => {
          let goToUrl;
          $("#userToken").val(userinfo.userToken);

          if (userinfo.userToken) {
            goToUrl = "certificateToUpdate/";
          } else {
            // IOS에서 WS연동이 안되는 중(https일때)
            if (phonecfg.phoneOS === "ANDROID") {
              goToUrl = "certificate2/";
            } else {
              goToUrl = "certificate2/";
            }
          }

          $.get(cfg.webUrl + goToUrl, function (data) {
            $("#enc_data").val(data.encData);

            document.form_certificate.action =
              "https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb";
            document.form_certificate.target = "_self";
            document.form_certificate.submit();
          });
        }}
      >
        본인인증하기
      </BtnNext>
    </div>
  );

  return (
      <Fragment>
          <ContainerNew
              Title={"본인인증"}
              dark={"dark"}
              leftMenu={SubMenu}
              rightMenu={-1}
              bottom={bottom}
              isMain={true}
          >
              <Contents>
                  <SubTitle>본인 휴대전화 인증</SubTitle>

                  <div style={{ textAlign: "center" }}>
                      <img
                          src={IC.etc.IC_GRAY_CERTIFI}
                          style={{ width: "80px", padding: "24px 0px" }}
                      />
                      <p style={{ fontSize: "16px", padding: "8px 0px" }}>
                          최초 1회 본인 인증이 필요합니다.
                      </p>

                      <p style={{ color: "#898989" }}>
                          본인인증시 수집된 개인정보는 서비스외에 다른 용도로
                      </p>
                      <p style={{ color: "#898989" }}>사용되지 않습니다.</p>
                  </div>

                  <div style={{ position: "absolute", bottom: "0px" }}>
                      <p style={{ color: "#898989" }}>
                          인증비용은 케어포미에서 부담합니다.
                      </p>
                      <p style={{ color: "#898989" }}>
                          인증받은 전화번호는 내 정보에 등록됩니다.
                      </p>
                  </div>
              </Contents>
          </ContainerNew>
      </Fragment>
  );
};

const Contents = ({ children }) => {
  return (
    <div className="contents">
      <div className="sub-contents">{children}</div>
    </div>
  );
};

const SubTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-top: 37px;
`;

const BtnNext = styled.div`
  bottom: 86px;
  width: ${(props) => window.innerWidth - 30}px;
  height: 50px;
  line-height: 50px;
  background: #000000 0% 0% no-repeat padding-box;
  color: #fff;
  border-radius: 4px;
  opacity: 1;
  font-size: 17px;
`;
